import { VenueGroup, venues, venuesGroupsMap } from 'common/constants/venues';
import { CalculatorFormValues, EventSpaceMeasureUnit, FoodSource } from 'common/types';
import { useState } from 'react';

const defaultVenuesGroup = VenueGroup.GRIMALDI_FORUM;
const defaultVenue = venuesGroupsMap[defaultVenuesGroup][0];
const defaultVenueSize = venues.find(({ name }) => name === defaultVenue)?.m2Size;

const initialFormValues: CalculatorFormValues = {
  eventSpaceMeasureUnit: EventSpaceMeasureUnit.m2,
  welcome: [],
  foodSource: FoodSource.AllFoodIsLocallySorced,

  hasExhibitors: false,
  eventVenuesGroup: defaultVenuesGroup,
  eventVenue: defaultVenue,
  eventVenueSize: defaultVenueSize,
};

export const useFormValues = () => {
  const [formValues, setFormValues] = useState<CalculatorFormValues>(initialFormValues);
  return { initialFormValues, formValues, setFormValues } as const;
};
